<div class="portada text-center pt-1 pb-5 ">

  <div>
    <img class="logo" src="{{logo}}" alt="Logo Hogar Jesus Amigo">

    <h1 class="titulo"><strong>{{titulo}}</strong></h1>

    <img class="fondo" src="{{fondo}}" alt="Fondo de portada">
  </div>

</div>
